<template>
  <p class="m-0 whitespace-pre-line [overflow-wrap:anywhere]">
    <template v-for="(part, index) in parts">
      <img
        v-if="part.emoji"
        :key="'emoji-' + index"
        :src="part.src"
        :alt="part.text"
        class="inline-block size-[1.1em] align-[-0.2em]"
      >
      <span v-else :key="'text-' + index">{{ part.text }}</span>
    </template>
  </p>
</template>

<script>
import emojiData from 'emoji-mart-vue-fast/data/facebook.json';
import emojiRegexBuilder from 'emoji-regex';

const emojiRegex = emojiRegexBuilder();

/** Post text with the emojis drawn as Facebook-style images. */
export default {
  name: 'PostContentText',
  props: {
    text: {
      type: [ String, null ],
      required: true,
    },
  },
  computed: {
    parts() {
      const text = this.text || '';
      const parts = [];
      let last = 0;

      for (const match of text.matchAll(emojiRegex)) {
        const codePoint = [ ...match[0] ].map(char => char.codePointAt(0).toString(16)).join('-').toUpperCase();
        const emoji = Object.values(emojiData.emojis).find(item => item.b === codePoint || item.c === codePoint);
        if (!emoji) {
          continue;
        }

        if (match.index > last) {
          parts.push({ text: text.slice(last, match.index) });
        }
        parts.push({
          emoji: true,
          text: match[0],
          src: process.env.VUE_APP_CDN_URL + '/emoji/' + emoji.b.toLowerCase() + '.png',
        });
        last = match.index + match[0].length;
      }

      if (last < text.length) {
        parts.push({ text: text.slice(last) });
      }

      return parts;
    },
  },
};
</script>
